
import React from 'react';
import { Clock, ListIcon, Wallet } from "lucide-react";
import { useApiGetTimeSummaryDetail } from "@/api/lesson";

function TimeSummary({ args }) {
    const { data: summaryDetail, isPending } = useApiGetTimeSummaryDetail(args);

    return (
        <div className="grid lg:grid-cols-3 grid-cols-1 gap-4">

            {/* MONEY */}
            <div className="
                relative overflow-hidden
                bg-gradient-to-br from-emerald-50 to-emerald-100
                dark:from-emerald-950/50 dark:to-emerald-900/40
                rounded-2xl
                p-5
                border border-emerald-200 dark:border-emerald-800/70
                shadow-sm
            ">
                <div className="absolute top-0 left-0 w-24 h-24 bg-emerald-200/30 dark:bg-emerald-500/10 rounded-full blur-2xl" />

                <div className="relative">
                    <div className="flex items-center justify-between mb-5">
                        <div>
                            <div className="text-xs text-emerald-700 dark:text-emerald-300">
                                جمع مبالغ
                            </div>

                            <div className="text-3xl font-black text-emerald-900 dark:text-emerald-100 mt-2">
                                {summaryDetail?.data?.data?.total_finalprice.toLocaleString('fa-IR')}
                            </div>

                            <div className="text-xs text-emerald-700 dark:text-emerald-300 mt-1">
                                تومان
                            </div>
                        </div>

                        <div className="
                            w-12 h-12 rounded-xl
                            bg-white/70 dark:bg-emerald-900/60
                            flex items-center justify-center
                        ">
                            <Wallet className="w-6 h-6 text-emerald-700 dark:text-emerald-300" />
                        </div>
                    </div>
                </div>
            </div>

            {/* TIME */}
            <div className="
                relative overflow-hidden
                bg-gradient-to-br from-orange-50 to-orange-100
                dark:from-orange-950/50 dark:to-orange-900/40
                rounded-2xl
                p-5
                border border-orange-200 dark:border-orange-800/70
                shadow-sm
            ">
                <div className="absolute top-0 left-0 w-24 h-24 bg-orange-200/30 dark:bg-orange-500/10 rounded-full blur-2xl" />

                <div className="relative">
                    <div className="flex items-center justify-between mb-5">
                        <div>
                            <div className="text-xs text-orange-700 dark:text-orange-300">
                                مجموع زمان فعالیت
                            </div>

                            <div className="text-3xl font-black text-orange-900 dark:text-orange-100 mt-2">
                                {summaryDetail?.data?.data?.total_time.toLocaleString('fa-IR')}
                            </div>

                            <div className="text-xs text-orange-700 dark:text-orange-300 mt-1">
                                ساعت
                            </div>
                        </div>

                        <div className="
                            w-12 h-12 rounded-xl
                            bg-white/70 dark:bg-orange-900/60
                            flex items-center justify-center
                        ">
                            <Clock className="w-6 h-6 text-orange-700 dark:text-orange-300" />
                        </div>
                    </div>
                </div>
            </div>

            {/* ROWS */}
            <div className="
                relative overflow-hidden
                bg-gradient-to-br from-blue-50 to-blue-100
                dark:from-blue-950/50 dark:to-blue-900/40
                rounded-2xl
                p-5
                border border-blue-200 dark:border-blue-800/70
                shadow-sm
            ">
                <div className="absolute top-0 left-0 w-24 h-24 bg-blue-200/30 dark:bg-blue-500/10 rounded-full blur-2xl" />

                <div className="relative">
                    <div className="flex items-center justify-between mb-5">
                        <div>
                            <div className="text-xs text-blue-700 dark:text-blue-300">
                                تعداد ردیف‌ها
                            </div>

                            <div className="text-3xl font-black text-blue-900 dark:text-blue-100 mt-2">
                                {summaryDetail?.data?.data?.total_count.toLocaleString('fa-IR')}
                            </div>

                            <div className="text-xs text-blue-700 dark:text-blue-300 mt-1">
                                ردیف
                            </div>
                        </div>

                        <div className="
                            w-12 h-12 rounded-xl
                            bg-white/70 dark:bg-blue-900/60
                            flex items-center justify-center
                        ">
                            <ListIcon className="w-6 h-6 text-blue-700 dark:text-blue-300" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default TimeSummary;
